export const HOA_DON_PERMISSION_CODES = {
  WEB_BH_HOA_DON_LIST: 'WEB_BH_HOA_DON_LIST',
  WEB_BH_HOA_DON_CHI_TIET_LIST: 'WEB_BH_HOA_DON_CHI_TIET_LIST',
  WEB_BH_HOA_DON_DETAIL: 'WEB_BH_HOA_DON_DETAIL',
  WEB_BH_HOA_DON_ADD: 'WEB_BH_HOA_DON_ADD',
  WEB_BH_HOA_DON_EDIT: 'WEB_BH_HOA_DON_EDIT',
  WEB_BH_HOA_DON_DELETE: 'WEB_BH_HOA_DON_DELETE',
  WEB_BH_HOA_DON_STATUS: 'WEB_BH_HOA_DON_STATUS',
  WEB_BH_HOA_DON_PAY: 'WEB_BH_HOA_DON_PAY',
  WEB_BH_HOA_DON_VAN_DON: 'WEB_BH_HOA_DON_VAN_DON',
  WEB_BH_HOA_DON_EXPORT: 'WEB_BH_HOA_DON_EXPORT',
  WEB_BH_HOA_DON_IMPORT: 'WEB_BH_HOA_DON_IMPORT',
  WEB_BH_HOA_DON_FAVORITE: 'WEB_BH_HOA_DON_FAVORITE',
  /** In nhiều hóa đơn đã chọn trên list — tách khỏi in từng dòng. */
  WEB_BH_HOA_DON_PRINT_BATCH: 'WEB_BH_HOA_DON_PRINT_BATCH',
  /** Hủy nhiều hóa đơn đã chọn trên list — tách khỏi hủy/đổi TT từng dòng. */
  WEB_BH_HOA_DON_HUY_BATCH: 'WEB_BH_HOA_DON_HUY_BATCH',
} as const

export const HOA_DON_MUTATE_PERMISSIONS = [
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_ADD,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_EDIT,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_DELETE,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_STATUS,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_PAY,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_VAN_DON,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_EXPORT,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_IMPORT,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_FAVORITE,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_PRINT_BATCH,
  HOA_DON_PERMISSION_CODES.WEB_BH_HOA_DON_HUY_BATCH,
] as const
